import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f0336f82"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("新增分類")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("新增課程")
const _hoisted_3 = { class: "dialog-footer" }
const _hoisted_4 = { class: "dialog-footer" }
const _hoisted_5 = { class: "dialog-footer" }
const _hoisted_6 = { class: "dialog-footer" }

import { ref, onMounted, reactive, computed } from "vue";
import { useI18n } from "vue-i18n";
import API from '@/apis/TPSAPI';
import { EditPen, Delete } from '@element-plus/icons-vue';
import { M_IUsers } from "@/models/M_IUser";
import { M_ICreateRuleForm, M_IUpdateRuleForm, M_IDeleteRuleForm } from '@/models/M_IRuleForm';
import { FormInstance, FormRules, ElNotification, NotificationParams, ElMessageBox  } from 'element-plus';
import {M_ICourseOptions} from "@/models/M_ICourseOptions";
import {M_ICourseTypeOptions} from "@/models/M_ICourseTypeOptions"; 
import { de } from "element-plus/es/locale";


export default /*#__PURE__*/_defineComponent({
  __name: 'CoursesMgmt',
  setup(__props) {


const isShowAddRoleDialog = ref(false);
const isShowEditRoleDialog = ref(false);
const isShowAddCourseTypeDialog =ref(false);
const isShowEditCourseTypeDialog = ref(false);
const { t } = useI18n();
const courseList = ref<M_ICourseOptions[]>([]);
const courseTypeList = ref<M_ICourseTypeOptions[]>([]);

// Computed filters
// const sortOrderFilters = computed(() => {
//   const uniqueValues = [...new Set(courseList.value.map(item => item.sortOrder))];
//   return uniqueValues.filter(val => val !== undefined).map(val => ({ text: String(val), value: val }));
// });

const courseTypeFilters = computed(() => {
  const uniqueValues = [...new Set(courseList.value.map(item => item.courseTypeName))];
  return uniqueValues.filter(val => val !== undefined).map(val => ({ text: val!, value: val }));
});

// Unified filter method
const filterColumn = (value: any, row: any, column: any) => {
  const property = column.property;
  return row[property] === value;
};



const Error = (error: string) => {
  let notifyParam: NotificationParams = {};
  notifyParam = {
      title: "錯誤",
      type: "error",
      message: error,
      duration: 1000,
  };
}

//#region UI Events
const onEdit = (item: M_ICourseOptions) => {
  console.log(item.courseName);
  updateRoleForm.value?.resetFields();
  updateFormData.courseId = item.courseId;
  updateFormData.courseName = item.courseName;
  updateFormData.courseTypeId = item.courseTypeId;
  updateFormData.IsDelete = false;
  // updateFormData.category = item.category;
  // updateFormData.sortOrder = item.sortOrder;
  // updateFormData.feeCode = item.feeCode;
  updateFormData.amount = item.amount;
  updateFormData.materialFee = item.materialFee;
  updateFormData.hours = item.hours;
  updateFormData.splitRatio = item.splitRatio;
  // updateFormData.openCourseAmount = item.openCourseAmount;
  updateFormData.remark = item.remark;
  isShowEditRoleDialog.value = true;
}

const onDelet = async(item: M_ICourseOptions) => {
 
  try {
    await ElMessageBox.confirm("確定刪除?", "提示", {
      confirmButtonText: "確定",
      cancelButtonText: "取消",
      type: "warning",
    });
  } catch (error) {
    return;
  }

  deleteFormData.courseId = item.courseId;
  deleteFormData.courseName = item.courseName;
  deleteFormData.IsDelete = true;

  let notifyParam: NotificationParams = {};

  try {
    const deleteResponse = await API.updateCourse(deleteFormData);
    if (deleteResponse.data.result != 1) throw new Error(deleteResponse.data.msg);
    notifyParam = {
      title: "成功",
      type: "success",
      message: `已刪除 ${deleteFormData.courseName}`,
      duration: 1000,
    };
    getCourseOptions();
  } catch (error) {
    notifyParam = {
      title: "錯誤",
      type: "error",
      message: (error as Error).message,
      duration: 3000,
    };
  } finally {
    ElNotification(notifyParam);
  }
}

const onEditCourseType = async (item: M_ICourseTypeOptions) => {
  console.log(item.courseTypeName);
  updateCourseTypeForm.value?.resetFields();
  updateCourseTypeFormData.courseTypeId = item.courseTypeId;
  updateCourseTypeFormData.courseTypeName = item.courseTypeName;
  updateCourseTypeFormData.IsDelete = false;
  isShowEditCourseTypeDialog.value = true;
}

const onCreateCourseClicked = () => {
  createaddRoleForm.value?.resetFields();
  isShowAddRoleDialog.value = true;
}

const onCreateCourseTypeClicked = () => {
  createaddCourseTypeForm.value?.resetFields();
  isShowAddCourseTypeDialog.value = true;
}

const submitForm = async () => {
  let notifyParam: NotificationParams = {};

  createaddRoleForm.value?.validate(async(valid) => {
    if (valid) {
      const addUser = await API.addCourse(createFormData);
      if (addUser.data.result != 1) {
        notifyParam = {
          title: "失敗",
          type: "error",
          message: `課程：${createFormData.courseName} 新增失敗<br>原因：${addUser.data.msg}`,
          duration: 2000,
          dangerouslyUseHTMLString: true
        };
      }else{
        notifyParam = {
          title: "成功",
          type: "success",
          message: `課程：${createFormData.courseName} 已成功新增`,
          duration: 3000,
          dangerouslyUseHTMLString: true // 啟用 HTML 字符串，message 中使用<br>。
        };
      }

      ElNotification(notifyParam);
      isShowAddRoleDialog.value = false;
      getCourseOptions();

    } else {
      console.log('error submit!')
    }
  })
};

const submitCourseTypeForm = async () => {
  let notifyParam: NotificationParams = {};

  createaddCourseTypeForm.value?.validate(async(valid) => {
    if (valid) {
      const addUser = await API.addCourseType(createCourseTypeFormData);
      if (addUser.data.result != 1) {
        notifyParam = {
          title: "失敗",
          type: "error",
          message: `課程：${createCourseTypeFormData.courseTypeName} 新增失敗`,
          duration: 2000,
          dangerouslyUseHTMLString: true
        };
      }else{
        notifyParam = {
          title: "成功",
          type: "success",
          message: `課程：${createCourseTypeFormData.courseTypeName} 已成功新增`,
          duration: 3000,
          dangerouslyUseHTMLString: true // 啟用 HTML 字符串，message 中使用<br>。
        };
      }

      ElNotification(notifyParam);
      isShowAddCourseTypeDialog.value = false;
      getCourseOptions();
      getCourseTypeOptions();

    } else {
      console.log('error submit!')
    }
  })
};

const submitUpdateForm = async () => {
  let notifyParam: NotificationParams = {};

  updateRoleForm.value?.validate(async (valid: boolean) => {
    if (valid) {
      console.log(updateFormData);
      const updateResponse = await API.updateCourse(updateFormData);
      console.log(updateResponse.data.msg);

      if (updateResponse.data.result != 1) {
        notifyParam = {
          title: "失敗",
          type: "error",
          message: `課程：${updateFormData.courseName} 更新失敗`,
          duration: 2000,
        };
      } else {
        notifyParam = {
          title: "成功",
          type: "success",
          message: `帳號：${updateFormData.courseName} 已成功更新`,
          duration: 2000,
        };
        getCourseOptions();
      }

      ElNotification(notifyParam);
      isShowEditRoleDialog.value = false;
    } else {
      console.log('error submit!');
    }
  });
};

const submitCourseTypeUpdateForm = async () => {
  let notifyParam: NotificationParams = {};

  updateCourseTypeForm.value?.validate(async (valid: boolean) => {
    if (valid) {
      console.log(updateCourseTypeFormData);
      const updateResponse = await API.updateCourseType(updateCourseTypeFormData);
      console.log(updateResponse.data.msg);

      if (updateResponse.data.result != 1) {
        notifyParam = {
          title: "失敗",
          type: "error",
          message: `課程：${updateCourseTypeFormData.courseTypeName} 更新失敗`,
          duration: 2000,
        };
      } else {
        notifyParam = {
          title: "成功",
          type: "success",
          message: `帳號：${updateCourseTypeFormData.courseTypeName} 已成功更新`,
          duration: 2000,
        };
          getCourseOptions();
          getCourseTypeOptions();
      }

      ElNotification(notifyParam);
      isShowEditCourseTypeDialog.value = false;
    } else {
      console.log('error submit!');
    }
  });
};

//#endregion

//#region 建立表單ref與Validator
// 新增課程表單
const createaddRoleForm = ref<FormInstance>()
const createFormData = reactive<M_ICourseOptions>({
  courseName: '',
  courseTypeId: 0,
  // category: undefined,
  // sortOrder: undefined,
  // feeCode: undefined,
  amount: undefined,
  materialFee: undefined,
  hours: undefined,
  splitRatio: undefined,
  // openCourseAmount: undefined,
  remark: undefined
})

// 編輯課程表單
const updateRoleForm = ref<FormInstance>()
const updateFormData = reactive<M_ICourseOptions>({
 courseName: '',
 courseTypeId: 0,
 IsDelete: false,
//  category: undefined,
//  sortOrder: undefined,
//  feeCode: undefined,
 amount: undefined,
 materialFee: undefined,
 hours: undefined,
 splitRatio: undefined,
//  openCourseAmount: undefined,
 remark: undefined
})

const deleteFormData = reactive<M_ICourseOptions>({
  courseName: '',
  IsDelete: true
})

// 新增分類表單
const createaddCourseTypeForm = ref<FormInstance>()
const createCourseTypeFormData = reactive<M_ICourseTypeOptions>({
  courseTypeName: ''
})

// 編輯分類表單
const updateCourseTypeForm = ref<FormInstance>()
const updateCourseTypeFormData = reactive<M_ICourseTypeOptions>({
 courseTypeName: '',
 IsDelete: false
})

// 新增表單, 編輯表單共用規則
const rules  = reactive<FormRules>({
  courseName: [{ required: true, message: () => t("validation_msg.coursename_is_required"), trigger: "blur" }],
  courseTypeName: [{ required: true, message: () => t("validation_msg.coursetype_is_required"), trigger: "blur" }],
});

const editRules  = reactive<FormRules>({
  courseName: [{ required: true, message: () => t("validation_msg.coursename_is_required"), trigger: "blur" }],
});


//#endregion

//#region Hook functions
// onActivated(() => {
  
// });
onMounted(() => {
  getCourseOptions();
  getCourseTypeOptions();
});

//#endregion

//#region Private Functions
async function getCourseOptions () {
  try {
      const response = await API.getCourse();
      courseList.value = response.data.content.sort((a: M_ICourseOptions, b: M_ICourseOptions) =>
        (a.courseTypeId ?? 0) - (b.courseTypeId ?? 0)
      )
      console.log(courseList.value)
    } catch (error) {
      console.error('載入課程資料失敗:', error);
    }
}

async function getCourseTypeOptions () {
  try {
      const response = await API.getCourseType();
      courseTypeList.value = response.data.content
      console.log(courseTypeList.value)
    } catch (error) {
      console.error('載入課程資料失敗:', error);
    }
}
//#endregion

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, {
          span: 6,
          style: {"padding":"10px"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: onCreateCourseTypeClicked
            }, {
              default: _withCtx(() => [
                _hoisted_1
              ]),
              _: 1
            }),
            _createVNode(_component_el_table, {
              name: "userInfoTable",
              style: {"width":"100%"},
              data: courseTypeList.value
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  sortable: "",
                  label: _unref(t)('Course Type'),
                  prop: "courseTypeName"
                }, null, 8, ["label"]),
                _createVNode(_component_el_table_column, {
                  width: "170px",
                  align: "center",
                  prop: "operate",
                  class: "operateBtnGroup d-flex",
                  label: _unref(t)('operation')
                }, {
                  default: _withCtx(({ row }: { row: any }) => [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      size: "small",
                      onClick: ($event: any) => (onEditCourseType(row))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_unref(EditPen))
                          ]),
                          _: 1
                        }),
                        _createTextVNode(_toDisplayString(_unref(t)('edit')), 1)
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]),
                  _: 1
                }, 8, ["label"])
              ]),
              _: 1
            }, 8, ["data"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, {
          span: 18,
          style: {"padding":"10px"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: onCreateCourseClicked
            }, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            }),
            _createVNode(_component_el_table, {
              name: "userInfoTable",
              style: {"width":"100%"},
              data: courseList.value,
              "default-sort": { prop: 'courseTypeId', order: 'ascending' }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  sortable: "",
                  label: _unref(t)('Course Type'),
                  prop: "courseTypeName",
                  filters: _unref(courseTypeFilters),
                  "filter-method": filterColumn,
                  "column-key": "courseTypeName"
                }, null, 8, ["label", "filters"]),
                _createVNode(_component_el_table_column, {
                  sortable: "",
                  label: _unref(t)('Course Name'),
                  prop: "courseName"
                }, null, 8, ["label"]),
                _createVNode(_component_el_table_column, {
                  sortable: "",
                  label: "課程費用",
                  prop: "amount"
                }),
                _createVNode(_component_el_table_column, {
                  sortable: "",
                  label: "教材費",
                  prop: "materialFee"
                }),
                _createVNode(_component_el_table_column, {
                  sortable: "",
                  label: "課程時數",
                  prop: "hours"
                }),
                _createVNode(_component_el_table_column, {
                  sortable: "",
                  label: "預設拆帳比",
                  prop: "splitRatio"
                }),
                _createVNode(_component_el_table_column, {
                  sortable: "",
                  label: "備註",
                  prop: "remark"
                }),
                _createVNode(_component_el_table_column, {
                  width: "170px",
                  align: "center",
                  prop: "operate",
                  class: "operateBtnGroup d-flex",
                  label: _unref(t)('operation')
                }, {
                  default: _withCtx(({ row }: { row: any }) => [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      size: "small",
                      onClick: ($event: any) => (onEdit(row))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_unref(EditPen))
                          ]),
                          _: 1
                        }),
                        _createTextVNode(_toDisplayString(_unref(t)('edit')), 1)
                      ]),
                      _: 2
                    }, 1032, ["onClick"]),
                    ((row.userId != 51))
                      ? (_openBlock(), _createBlock(_component_el_button, {
                          key: 0,
                          type: "danger",
                          size: "small",
                          onClick: ($event: any) => (onDelet(row))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_icon, null, {
                              default: _withCtx(() => [
                                _createVNode(_unref(Delete))
                              ]),
                              _: 1
                            }),
                            _createTextVNode(_toDisplayString(_unref(t)('delete')), 1)
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["label"])
              ]),
              _: 1
            }, 8, ["data"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_dialog, {
      class: "dialog",
      modelValue: isShowAddRoleDialog.value,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((isShowAddRoleDialog).value = $event)),
      title: _unref(t)('create')
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_3, [
          _createVNode(_component_el_button, {
            onClick: _cache[7] || (_cache[7] = ($event: any) => (isShowAddRoleDialog.value = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)("Cancel")), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[8] || (_cache[8] = ($event: any) => (submitForm()))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)("Confirm")), 1)
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          "label-width": "100px",
          ref_key: "createaddRoleForm",
          ref: createaddRoleForm,
          rules: rules,
          model: createFormData
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: _unref(t)('Course Name'),
              prop: "courseName"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  style: {"width":"90%"},
                  modelValue: createFormData.courseName,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((createFormData.courseName) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: "課程分類",
              prop: "courseTypeId"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  style: {"width":"90%"},
                  modelValue: createFormData.courseTypeId,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((createFormData.courseTypeId) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: "=未選擇分類=",
                      value: 0
                    }),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(courseTypeList.value, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.courseTypeId,
                        label: item.courseTypeName,
                        value: item.courseTypeId
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "課程費用",
                      prop: "amount",
                      "label-width": "100px"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input_number, {
                          style: {"width":"75%"},
                          modelValue: createFormData.amount,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((createFormData.amount) = $event)),
                          controls: false
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "教材費",
                      prop: "materialFee",
                      "label-width": "100px"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input_number, {
                          style: {"width":"75%"},
                          modelValue: createFormData.materialFee,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((createFormData.materialFee) = $event)),
                          controls: false
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "課程時數",
                      prop: "hours",
                      "label-width": "100px"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input_number, {
                          style: {"width":"75%"},
                          modelValue: createFormData.hours,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((createFormData.hours) = $event)),
                          precision: 2,
                          controls: false
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "拆帳比例",
                      prop: "splitRatio",
                      "label-width": "100px"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input_number, {
                          style: {"width":"75%"},
                          modelValue: createFormData.splitRatio,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((createFormData.splitRatio) = $event)),
                          min: 0,
                          max: 1,
                          precision: 2,
                          step: 0.01,
                          controls: false
                        }, null, 8, ["modelValue", "step"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "課程說明/備註",
              prop: "remark"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  style: {"width":"90%"},
                  type: "textarea",
                  rows: 3,
                  modelValue: createFormData.remark,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((createFormData.remark) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["rules", "model"])
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(_component_el_dialog, {
      class: "dialog",
      modelValue: isShowEditRoleDialog.value,
      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((isShowEditRoleDialog).value = $event)),
      title: _unref(t)('edit')
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_4, [
          _createVNode(_component_el_button, {
            onClick: _cache[17] || (_cache[17] = ($event: any) => (isShowEditRoleDialog.value = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)("Cancel")), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[18] || (_cache[18] = ($event: any) => (submitUpdateForm()))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)("Confirm")), 1)
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          "label-width": "100px",
          ref_key: "updateRoleForm",
          ref: updateRoleForm,
          rules: editRules,
          model: updateFormData
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: _unref(t)('Course Name'),
              prop: "courseName"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  style: {"width":"90%"},
                  modelValue: updateFormData.courseName,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((updateFormData.courseName) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: "課程分類",
              prop: "courseTypeName"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  style: {"width":"90%"},
                  modelValue: updateFormData.courseTypeId,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((updateFormData.courseTypeId) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: "=未選擇分類=",
                      value: 0
                    }),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(courseTypeList.value, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.courseTypeId,
                        label: item.courseTypeName,
                        value: item.courseTypeId
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "課程費用",
                      prop: "amount"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input_number, {
                          style: {"width":"75%"},
                          modelValue: updateFormData.amount,
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((updateFormData.amount) = $event)),
                          controls: false
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "教材費",
                      prop: "materialFee"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input_number, {
                          style: {"width":"75%"},
                          modelValue: updateFormData.materialFee,
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((updateFormData.materialFee) = $event)),
                          controls: false
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "課程時數",
                      prop: "hours"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input_number, {
                          style: {"width":"75%"},
                          modelValue: updateFormData.hours,
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((updateFormData.hours) = $event)),
                          precision: 0,
                          controls: false
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "拆帳比例",
                      prop: "splitRatio"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input_number, {
                          style: {"width":"75%"},
                          modelValue: updateFormData.splitRatio,
                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((updateFormData.splitRatio) = $event)),
                          min: 0,
                          max: 1,
                          precision: 2,
                          controls: false
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "課程說明/備註",
              prop: "remark"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  style: {"width":"90%"},
                  type: "textarea",
                  rows: 3,
                  modelValue: updateFormData.remark,
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((updateFormData.remark) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["rules", "model"])
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(_component_el_dialog, {
      class: "dialog",
      modelValue: isShowAddCourseTypeDialog.value,
      "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((isShowAddCourseTypeDialog).value = $event)),
      title: _unref(t)('create')
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_5, [
          _createVNode(_component_el_button, {
            onClick: _cache[21] || (_cache[21] = ($event: any) => (isShowAddCourseTypeDialog.value = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)("Cancel")), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[22] || (_cache[22] = ($event: any) => (submitCourseTypeForm()))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)("Confirm")), 1)
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          "label-width": "100px",
          ref_key: "createaddCourseTypeForm",
          ref: createaddCourseTypeForm,
          rules: rules,
          model: createCourseTypeFormData
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: _unref(t)('Course Type'),
              prop: "courseTypeName"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  style: {"width":"90%"},
                  modelValue: createCourseTypeFormData.courseTypeName,
                  "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((createCourseTypeFormData.courseTypeName) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        }, 8, ["rules", "model"])
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(_component_el_dialog, {
      class: "dialog",
      modelValue: isShowEditCourseTypeDialog.value,
      "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((isShowEditCourseTypeDialog).value = $event)),
      title: _unref(t)('edit')
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_6, [
          _createVNode(_component_el_button, {
            onClick: _cache[25] || (_cache[25] = ($event: any) => (isShowEditCourseTypeDialog.value = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)("Cancel")), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[26] || (_cache[26] = ($event: any) => (submitCourseTypeUpdateForm()))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)("Confirm")), 1)
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          "label-width": "100px",
          ref_key: "updateCourseTypeForm",
          ref: updateCourseTypeForm,
          rules: editRules,
          model: updateCourseTypeFormData
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: _unref(t)('Course Name'),
              prop: "courseTypeName"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  style: {"width":"90%"},
                  modelValue: updateCourseTypeFormData.courseTypeName,
                  "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((updateCourseTypeFormData.courseTypeName) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        }, 8, ["rules", "model"])
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ], 64))
}
}

})